import { select } from 'redux-saga/effects';
import {
  PapiRequestDaSharedGallectionFolders,
  PapiDaSharedGallectionFolders,
} from '@wix/da-papi-types';
import { getNextOffset } from '@wix/da-shared-react/pkg/Stream/withOffset/selectors';
import { fetchStreamContents } from '@wix/da-shared-react/pkg/Stream/helpers';
import { getItemsPerFetch, getStreamParam } from '@wix/da-shared-react/pkg/Stream/base/selectors';

export function* handleFetchNextGallerySubfolders({ payload: { streamId } }) {
  const { offset, limit, folderId, username } = yield select(state => ({
    offset: getNextOffset(state, streamId),
    limit: getItemsPerFetch(state, streamId),
    folderId: getStreamParam(state, streamId, 'folderId'),
    username: getStreamParam(state, streamId, 'username'),
  }));

  yield fetchStreamContents<PapiRequestDaSharedGallectionFolders, PapiDaSharedGallectionFolders>({
    streamId: streamId,
    params: {
      type: 'gallery',
      with_subfolders: true,
      username,
      folderid: folderId < 0 ? undefined : folderId,
      offset,
      limit,
    },
    url: 'gallection/folders',
    getStreamData: result => ({
      hasMore: !!result.hasMore,
      items: result.results,
      nextOffset: result.nextOffset ?? undefined,
    }),
  });
}
